import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useData } from '../hooks/useData';

const BlogPage = () => {
  const { data: blogData, loading, error } = useData('blog.json');

  if (loading) return <div className="container mx-auto p-4 text-center">Loading blog posts...</div>;
  if (error) return <div className="container mx-auto p-4 text-center text-red-500">Error loading blog posts: {error}</div>;
  if (!blogData || !blogData.posts) return <div className="container mx-auto p-4 text-center">No blog posts found.</div>;

  const posts = blogData.posts;

  return (
    <>
      <Helmet>
        <title>AI Blog - AI News</title>
        <meta name="description" content="Read insightful articles, tutorials, and case studies on AI and machine learning." />
        <meta name="keywords" content="AI blog, machine learning tutorials, AI case studies, artificial intelligence articles" />
      </Helmet>
      <div className="container mx-auto p-4">
        <header className="my-8 text-center">
          <h1 className="text-4xl font-bold text-gray-100">AI Blog</h1>
          <p className="text-lg text-gray-300 mt-2">Insights, tutorials, and stories from the world of AI.</p>
        </header>

        <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post) => (
            <article key={post.id} className="card hover:shadow-xl transition-shadow">
              <div className="mb-4">
                <span className="text-secondary-blue font-semibold">{post.category}</span>
                <span className="text-gray-400 ml-2">{post.date}</span>
              </div>
              <h2 className="text-xl font-bold mb-2 text-gray-100">{post.title}</h2>
              <p className="text-gray-300 mb-4 text-sm">{post.summary}</p>
              <div className="text-xs text-gray-400 mb-2">
                <span>By {post.author}</span>
                <span className="mx-2">•</span>
                <span>{post.readingTime} read</span>
              </div>
              <Link
                to={`/blog/${post.slug}`}
                className="text-secondary-blue font-semibold hover:underline text-sm"
              >
                Read More →
              </Link>
            </article>
          ))}
        </section>
      </div>
    </>
  );
};

export default BlogPage; 